import { createBrowserHistory } from 'history';

import type { History } from 'history';

const browserHistory: History = createBrowserHistory();

// We only want to export the location to allow read-only operations where we
// cannot reasonably use useLocation() to do so. Any mutation done on history
// will cause the history to become out of sync with history used within react-router.
// see navigation.md for more info on how to use history.
export const { location: historyLocation } = browserHistory;
